// React Router Dom
import { useLocation } from 'react-router-dom'

// Interfaces
import { IBaseOverlayLoaderProps } from './interfaces'

// Antd
import { Spin } from 'antd'

// i18n
import { useTranslation } from 'react-i18next'
import { LoadingOutlined } from '@ant-design/icons'

// Styles
import './styles.scss'

const BaseOverlayLoader = ({ isLazyLoading }: IBaseOverlayLoaderProps) => {
  // Hook
  const { t } = useTranslation()
  const { pathname } = useLocation()

  return isLazyLoading && (!pathname.includes('back-office') || pathname === '/') ? (
    <div className="base-overlay-loader">
      <div>
        <Spin size="large" indicator={<LoadingOutlined color="primary" />} />
        <p className="font-weight-400 text-primary font-24">
          {t('app.loading')} {t('app.app')}...
        </p>
      </div>
    </div>
  ) : (
    <></>
  )
}

export { BaseOverlayLoader }
